import { z } from 'zod'

export const dateStringToDateSchema = z.string().transform((str) => {
	const date = new Date(str)
	if (isNaN(date.getTime())) {
		throw new Error('Invalid date format')
	}
	return date
})
